var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    attrs: {
      "to": "/weapon/".concat(_vm.weapon.m_ID)
    }
  }, [_vm.collection ? [_c('v-list-item-avatar', {
    attrs: {
      "size": 48,
      "tile": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.weaponicon.format(_vm.$store.state.$db.WeaponList[_vm.id].m_ResourceID_R) + '.jpg'
    }
  })], 1), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$name(_vm.weapon.m_WeaponName)))])] : [_c('v-list-item-avatar', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "size": _vm.$size(),
      "tile": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.weaponicon.format(_vm.$store.state.$db.WeaponList[_vm.id].m_ResourceID_R) + '.jpg'
    }
  })], 1), _c('v-list-item-content', {
    staticClass: "mr-auto ml-0",
    staticStyle: {
      "max-width": "384px"
    }
  }, [_c('v-list-item-title', {
    staticClass: "d-flex align-center"
  }, [false ? [_vm._l(_vm.weapon.m_Rare + 1, function (i) {
    return _c('img', {
      key: "rare-icon-".concat(i),
      staticClass: "d-inline",
      attrs: {
        "width": _vm.rareIconSize,
        "height": _vm.rareIconSize,
        "src": _vm.$asset.commonuiatlas.format('RareIcon') + '.png'
      }
    });
  }), _c('span', {
    staticClass: "pr-1"
  })] : _vm._e(), _vm.weapon.m_Rare != 4 ? [_c('img', {
    attrs: {
      "width": _vm.$size() / 2.5,
      "height": _vm.$size() / 2.5,
      "src": _vm.$asset.commonuiatlas.format(_vm.classIcon) + '.png'
    }
  }), _c('span', {
    staticClass: "pr-1"
  })] : _vm._e(), _vm._v(_vm._s(_vm.$name(_vm.weapon.m_WeaponName)))], 2), _c('v-list-item-subtitle', [_c('Status', {
    attrs: {
      "status": _vm.status,
      "divide": "3"
    }
  })], 1)], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }